import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { changeLocale } from 'redux/modules/app'

// This component should be in components and not containers and actions should be passed over props
@connect(null, {
  changeLocale
})
class LocaleSwitch extends Component {
  static propTypes = {
    changeLocale: PropTypes.func.isRequired
  }

  handleChangeLocale = locale => {
    this.props.changeLocale(locale)
  }

  render() {
    return (
      <ul className="list">
        <li>
          <button onClick={() => this.handleChangeLocale('en')}>EN</button>
        </li>
        <li>
          <button onClick={() => this.handleChangeLocale('cs')}>CS</button>
        </li>
      </ul>
    )
  }
}

export default LocaleSwitch
